import React from 'react'

import { useSchedulerSelection } from '@/components/integration/nylas/scheduler/context/SchedulerSelectionContext'
import { Calendar } from '@/components/ui/calendar'
import { cn } from '@/lib/utils'

type CalendarComponents = NonNullable<
  React.ComponentProps<typeof Calendar>['components']
>

const CalendarDay: NonNullable<CalendarComponents['Day']> =
  function CalendarDay({ day, modifiers, children, ...props }) {
    const { selectedDateRange } = useSchedulerSelection()
    const month = selectedDateRange.start
    const isInCurrentMonth = day.date.getMonth() === month.getMonth()
    const dayNumber = day.date.getDate()

    if (!isInCurrentMonth) {
      return <div />
    }

    return (
      <div
        {...props}
        data-selected={modifiers.selected || undefined}
        data-today={modifiers.today || undefined}
        data-outside={modifiers.outside || undefined}
        data-disabled={modifiers.disabled || undefined}
        className="pop-in block text-center"
        style={{
          animationDelay: `${dayNumber * 8}ms`,
          animationFillMode: 'both',
        }}
      >
        <div
          className={cn(
            'grid w-full max-w-full place-items-center text-center',
          )}
        >
          {children}
        </div>
      </div>
    )
  }

export default CalendarDay
